export const ERROR_CODES = {
    UNKNOWN : 0,
    MODEL_ERROR: 1,
    PROBLEM_ERROR : 2,
    SOLUTION_ERROR  : 3,
    BAD_TOC : 4
};


// WEBPACK FOOTER //
// ./src/helpers/ErrorCodes.js